import { useFormContext } from "react-hook-form";
import { Textarea } from "../ui/textarea";
import { cn } from "@/lib/utils";

export default function QuickNotesSection() {
    const { register, formState } = useFormContext();

    return (
        <div className="space-y-2 bg-card">
            <Textarea
                {...register("quick_notes")}
                placeholder="Add notes..."
                rows={1}
                className={cn(
                    "text-xs bg-transparent ",
                    "placeholder:text-muted-foreground/40 placeholder:font-normal",
                    "resize-none min-h-[40px] px-3",
                    formState.errors?.quick_notes && "border-b-destructive/60"
                )}
                maxLength={300}
            />
            {formState.errors?.quick_notes && (
                <div className="text-xs text-destructive mt-1">
                    {formState.errors.quick_notes.message as string}
                </div>
            )}
        </div>
    );
}